module.exports = __webpack_public_path__ + "static/groceries-e6fb40cdd8492f6b162b1bd80d8aa941.svg";